import { useMemo } from 'react';
import type { TicketVisitReportDto } from '@evimo/client/models';
import { mapTicketVisitDto } from '../utils';
import type { TicketVisitView } from '../types';

export function useTicketDetailVisits(
  visits: TicketVisitReportDto[] | undefined,
): TicketVisitView[] {
  return useMemo(() => (visits ?? []).map(mapTicketVisitDto), [visits]);
}
